"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _mobx = require("mobx");
var _serializr = require("serializr");
var _utils = require("@seedlang/utils");
var _stores = require("@seedlang/stores");
var _layouts = require("@seedlang/layouts");
var _lodash = require("lodash");
var _models = require("@seedlang/models");
var _root_state = _interopRequireDefault(require("./root_state"));
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var ExerciseUI = (_class = /*#__PURE__*/function (_RootState) {
  function ExerciseUI() {
    var _this;
    _classCallCheck(this, ExerciseUI);
    _this = _callSuper(this, ExerciseUI);
    _initializerDefineProperty(_this, "worksheetId", _descriptor, _this);
    _initializerDefineProperty(_this, "exerciseId", _descriptor2, _this);
    _initializerDefineProperty(_this, "assignedExercise", _descriptor3, _this);
    _initializerDefineProperty(_this, "revealed", _descriptor4, _this);
    _initializerDefineProperty(_this, "currentCardId", _descriptor5, _this);
    _initializerDefineProperty(_this, "exercises", _descriptor6, _this);
    _initializerDefineProperty(_this, "exerciseRatingId", _descriptor7, _this);
    _this.assignExerciseToCard = function (cardId, exercise) {
      _this.exercises[cardId] = exercise;
    };
    _initializerDefineProperty(_this, "toggleHideYoutubeVideo", _descriptor8, _this);
    _initializerDefineProperty(_this, "updateUser", _descriptor9, _this);
    _this.webPosthogTrackingAllowed = function () {
      return (0, _utils.shouldTrackWebPosthog)({
        siteIsSeedlang: _this.siteIsSeedlang,
        user: _this.user,
        allowCookies: _this.getCookieValue('allow-cookies') === true
      });
    };
    _this.posthogEventParams = function (eventType) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return (0, _utils.buildWebPosthogEventProperties)({
        eventType: eventType,
        params: params,
        user: _this.user,
        site: _this.site
      });
    };
    _initializerDefineProperty(_this, "assignToNextWordAssociation", _descriptor0, _this);
    _this.getCookieValue = function (name) {
      return _this.cookieStore.getCookieValue(name);
    };
    _this.setCookieValue = function (name, value) {
      _this.cookieStore.setCookieValue(name, value);
    };
    _initializerDefineProperty(_this, "assignToNextExerciseEntry", _descriptor1, _this);
    _initializerDefineProperty(_this, "removeExerciseEntry", _descriptor10, _this);
    _initializerDefineProperty(_this, "onSetValueToWordAssociation", _descriptor11, _this);
    _initializerDefineProperty(_this, "clearWordAssociation", _descriptor12, _this);
    _initializerDefineProperty(_this, "setAssignedWordAssociations", _descriptor13, _this);
    _initializerDefineProperty(_this, "reset", _descriptor14, _this);
    _initializerDefineProperty(_this, "resetExerciseAnswers", _descriptor15, _this);
    _initializerDefineProperty(_this, "resetIncorrectExerciseAnswers", _descriptor16, _this);
    _initializerDefineProperty(_this, "revealExerciseEntryAnswer", _descriptor17, _this);
    _initializerDefineProperty(_this, "resetIncorrectExerciseEntryAnswers", _descriptor18, _this);
    _initializerDefineProperty(_this, "revealExerciseAnswers", _descriptor19, _this);
    _initializerDefineProperty(_this, "reloadUser", _descriptor20, _this);
    _initializerDefineProperty(_this, "afterGetExercise", _descriptor21, _this);
    _initializerDefineProperty(_this, "markAsCompleted", _descriptor22, _this);
    _this.findExerciseAndMarkAsCompleted = function (worksheetList) {
      worksheetList.forEach(function (worksheet) {
        var _worksheet$exercises;
        (_worksheet$exercises = worksheet.exercises) === null || _worksheet$exercises === void 0 || _worksheet$exercises.forEach(function (exercise) {
          if (exercise.id === _this.exerciseId) {
            exercise.set('completed', true);
          }
        });
      });
    };
    _initializerDefineProperty(_this, "updateIndexDataAfterMarkAsCompleted", _descriptor23, _this);
    _this.onClickRating = function (rating) {
      if ((0, _utils.isPresent)(_this.userExercise)) {
        var _this$user, _this$worksheet;
        _this.setUserExerciseValue('rating', rating);
        var data = {
          exerciseId: _this.exerciseId,
          userId: (_this$user = _this.user) === null || _this$user === void 0 ? void 0 : _this$user.id,
          rating: rating,
          languageId: _this.languageId,
          groupId: (_this$worksheet = _this.worksheet) === null || _this$worksheet === void 0 ? void 0 : _this$worksheet.groupId
        };
        _this.ratingStore.create({
          data: data
        }, function (resp) {
          return _this.exerciseRatingId = resp.id;
        });
      }
    };
    _this.onSubmitRatingComment = function (comment) {
      if (_this.exerciseRatingId) {
        _this.ratingStore.update({
          ids: {
            ratingId: _this.exerciseRatingId
          },
          data: {
            comment: comment
          }
        }, _lodash.noop);
      }
    };
    _this.routeUsesExerciseSlug = function (routeName) {
      var routeFirstPart = routeName === null || routeName === void 0 ? void 0 : routeName.split('.')[0];
      return ['creator', 'learn', 'worksheets', 'videos', 'podcast', 'exercises'].includes(routeFirstPart);
    };
    _this.routeParamForExercise = function (exercise) {
      var _this$routeStore;
      var routeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (_this$routeStore = _this.routeStore) === null || _this$routeStore === void 0 ? void 0 : _this$routeStore.routeName;
      if (_this.routeUsesExerciseSlug(routeName) && (0, _utils.isPresent)(exercise === null || exercise === void 0 ? void 0 : exercise.slug)) {
        return exercise.slug;
      }
      return exercise === null || exercise === void 0 ? void 0 : exercise.id;
    };
    _this.findWorksheetExerciseByParam = function (exerciseParam) {
      if (!_this.hasWorksheet || !(0, _utils.isPresent)(_this.worksheet.exercises)) {
        return null;
      }
      return _this.worksheet.exercises.find(function (item) {
        return item.id === exerciseParam || item.slug === exerciseParam;
      });
    };
    _this.goToNextExercise = function (callback, routeName) {
      if (_this.nextExercise) {
        _this.routeStore.routeToNamed(routeName, {
          worksheetId: _this.worksheetRouteParam,
          exerciseId: _this.routeParamForExercise(_this.nextExercise, routeName)
        }, callback);
      }
    };
    _this.goToPreviousExercise = function (callback, routeName) {
      if (_this.previousExercise) {
        _this.routeStore.routeToNamed(routeName, {
          worksheetId: _this.worksheetRouteParam,
          exerciseId: _this.routeParamForExercise(_this.previousExercise, routeName)
        }, callback);
      }
    };
    _this.setNativeCreateEventHandler = function (callback) {
      _this.nativeCreateEventHandler = callback;
    };
    _this.layout = new _layouts.AppLayout(_this);
    _this.soundEffectStore = _stores.SoundEffectStore;
    _this.xpState = _models.XpState;
    _this.authUserStore = _stores.AuthUserStore;
    _this.routeStore = _stores.RouteStore;
    _this.exerciseStore = _stores.ExerciseStore;
    _this.worksheetUserExerciseStore = _stores.WorksheetUserExerciseStore;
    _this.exerciseEntryStore = _stores.ExerciseEntryStore;
    _this.exerciseTypeStore = _stores.ExerciseTypeStore;
    _this.worksheetStore = _stores.WorksheetStore;
    _this.podcastWorksheetStore = _stores.PodcastWorksheetStore;
    _this.recentWorksheetStore = _stores.RecentWorksheetStore;
    _this.gridItemStore = _stores.GridItemStore;
    _this.gridItemWorksheetStore = _stores.GridItemWorksheetStore;
    _this.userGroupStore = _stores.UserGroupStore;
    _this.userExerciseStore = _stores.UserExerciseStore;
    _this.mediaOptionStore = _stores.MediaOptionStore;
    _this.tagCategoryStore = _stores.TagCategoryStore;
    _this.eventStore = _stores.EventStore;
    _this.worksheetWordStore = _stores.WorksheetWordStore;
    _this.cookieStore = _stores.CookieStore;
    _this.ratingStore = _stores.RatingStore;
    _this.reviewDeckStore = _stores.ReviewDeckStore;
    return _this;
  }
  _inherits(ExerciseUI, _RootState);
  return _createClass(ExerciseUI, [{
    key: "user",
    get: function get() {
      return this.authUserStore.showData;
    }
  }, {
    key: "userGroup",
    get: function get() {
      var _this2 = this;
      return this.userIsLoaded && this.groupId && this.user.userGroups.find(function (item) {
        return item.groupId === _this2.groupId;
      });
    }
  }, {
    key: "defaultExerciseId",
    get: function get() {
      if (this.hasWorksheet && (0, _utils.isPresent)(this.worksheet.exercises)) {
        var _this$worksheet2;
        return (_this$worksheet2 = this.worksheet) === null || _this$worksheet2 === void 0 || (_this$worksheet2 = _this$worksheet2.exercises[0]) === null || _this$worksheet2 === void 0 ? void 0 : _this$worksheet2.id;
      }
    }
  }, {
    key: "site",
    get: function get() {
      var _this$user2;
      return ((_this$user2 = this.user) === null || _this$user2 === void 0 ? void 0 : _this$user2.site) || {};
    }
  }, {
    key: "groupId",
    get: function get() {
      var _this$site;
      return (_this$site = this.site) === null || _this$site === void 0 ? void 0 : _this$site.groupId;
    }
  }, {
    key: "languageId",
    get: function get() {
      var _this$site2;
      return this.siteIsSeedlang ? 'DE' : (_this$site2 = this.site) === null || _this$site2 === void 0 ? void 0 : _this$site2.languageId;
    }
  }, {
    key: "siteIsSeedlang",
    get: function get() {
      return this.site.isSeedlang;
    }
  }, {
    key: "siteIsMemrev",
    get: function get() {
      return !this.siteIsSeedlang;
    }
  }, {
    key: "userIsSignedInAndNotGuest",
    get: function get() {
      return this.userIsLoaded;
    }
  }, {
    key: "worksheetWords",
    get: function get() {
      return this.worksheetWordStore.hasIndexData ? this.worksheetWordStore.indexData : [];
    }
  }, {
    key: "filteredWorksheetWords",
    get: function get() {
      return this.worksheetWordStore.hasIndexData && this.worksheetWords.filter(function (item) {
        return !item.invalid;
      });
    }
  }, {
    key: "worksheetHasInvalidVocab",
    get: function get() {
      return this.worksheetWords && this.worksheetWords.some(function (item) {
        return item.invalid;
      });
    }
  }, {
    key: "formattedYoutubeUrl",
    get: function get() {
      if (this.worksheetId && this.hasWorksheet) {
        var _this$worksheet3;
        return (_this$worksheet3 = this.worksheet) === null || _this$worksheet3 === void 0 ? void 0 : _this$worksheet3.formattedYoutubeUrl;
      }
      if (!this.worksheetId && this.exercise && this.exercise.worksheet) {
        return this.exercise.worksheet.formattedYoutubeUrl;
      }
    }
  }, {
    key: "userExercise",
    get: function get() {
      var _this3 = this;
      return this.worksheetUserExerciseStore.hasIndexData ? this.worksheetUserExerciseStore.indexData.find(function (item) {
        return item.exerciseId === _this3.exerciseId;
      }) : null;
    }
  }, {
    key: "worksheet",
    get: function get() {
      return this.worksheetStore.showData;
    }
  }, {
    key: "hasWorksheet",
    get: function get() {
      return this.worksheetStore.hasShowData;
    }
  }, {
    key: "exercise",
    get: function get() {
      if ((0, _utils.isPresent)(this.currentCardId) && this.exercises[this.currentCardId]) {
        return this.exercises[this.currentCardId];
      }
      if (this.exerciseStore.hasShowData && this.exerciseStore.showData.id === this.exerciseId) {
        return this.exerciseStore.showData;
      }
      if (this.hasWorksheet && this.exerciseId && (0, _utils.isPresent)(this.worksheet.exercises)) {
        return this.findWorksheetExerciseByParam(this.exerciseId);
      }
    }
  }, {
    key: "exerciseIsLast",
    get: function get() {
      return (0, _utils.isPresent)(this.exerciseId) && (0, _utils.isPresent)(this.worksheet.exercises) && this.exerciseIndex === this.worksheet.exercises.length - 1;
    }
  }, {
    key: "exerciseIsFirst",
    get: function get() {
      return (0, _utils.isPresent)(this.exerciseId) && (0, _utils.isPresent)(this.worksheet.exercises) && this.exerciseIndex === 0;
    }
  }, {
    key: "exerciseIndex",
    get: function get() {
      return (0, _utils.isPresent)(this.exerciseId) && (0, _utils.isPresent)(this.worksheet.exercises) && this.worksheet.exercises.map(function (item) {
        return item.id;
      }).indexOf(this.exerciseId);
    }
  }, {
    key: "userIsLoaded",
    get: function get() {
      return (0, _utils.isPresent)(this.user.id);
    }
  }, {
    key: "hasExercise",
    get: function get() {
      return (0, _utils.isPresent)(this.exercise);
    }
  }, {
    key: "createEventOnServer",
    value: function createEventOnServer(eventType, params) {
      this.eventStore.create({
        data: {
          eventType: eventType,
          params: params
        }
      }, _lodash.noop);
    }
  }, {
    key: "correctAnswersCount",
    value: function correctAnswersCount(exerciseId) {
      if (this.worksheetUserExerciseStore.hasIndexData) {
        var userExercise = this.worksheetUserExerciseStore.indexData.find(function (item) {
          return item.exerciseId === exerciseId;
        });
        if ((0, _utils.isPresent)(userExercise)) {
          return userExercise.correctAnswersCount;
        }
      }
      return 0;
    }
  }, {
    key: "setUserExerciseValue",
    value: function setUserExerciseValue(field, value) {
      if (!(0, _utils.isPresent)(this.userExercise)) {
        return;
      }
      if ((0, _lodash.isFunction)(this.userExercise.set)) {
        this.userExercise.set(field, value);
      } else {
        this.userExercise[field] = value;
      }
    }
  }, {
    key: "revealedEntriesCount",
    get: function get() {
      if ((0, _utils.isBlank)(this.exercise) || (0, _utils.isBlank)(this.exercise.exerciseEntries)) {
        return 0;
      }
      return this.exercise.exerciseEntries.filter(function (item) {
        return item.state.revealed;
      }).length;
    }
  }, {
    key: "revealedEntriesCorrectCount",
    get: function get() {
      if ((0, _utils.isBlank)(this.exercise) || (0, _utils.isBlank)(this.exercise.exerciseEntries)) {
        return 0;
      }
      return this.exercise.exerciseEntries.filter(function (item) {
        return item.state.revealed && item.state.correct;
      }).length;
    }
  }, {
    key: "updateIndexDataAfterReveal",
    value: function updateIndexDataAfterReveal() {
      var _this4 = this;
      if ((0, _utils.isPresent)(this.worksheetId) && this.worksheetUserExerciseStore.hasIndexData) {
        var totalCorrectAnswersCount = (0, _lodash.sum)(this.worksheetUserExerciseStore.indexData.map(function (item) {
          return item.correctAnswersCount;
        }));
        if (this.worksheetStore.hasIndexData) {
          var worksheetData = this.worksheetStore.indexData.find(function (item) {
            return (item === null || item === void 0 ? void 0 : item.id) === _this4.worksheetId;
          });
          if ((0, _utils.isPresent)(worksheetData)) {
            worksheetData.set('correctAnswersCount', totalCorrectAnswersCount);
          }
        }
        if (this.gridItemStore.hasIndexData) {
          this.gridItemStore.indexData.forEach(function (gridItem) {
            var _gridItem$gridItemWor;
            (_gridItem$gridItemWor = gridItem.gridItemWorksheets) === null || _gridItem$gridItemWor === void 0 || _gridItem$gridItemWor.forEach(function (gridItemWorksheet) {
              var _gridItemWorksheet$wo;
              if (((_gridItemWorksheet$wo = gridItemWorksheet.worksheet) === null || _gridItemWorksheet$wo === void 0 ? void 0 : _gridItemWorksheet$wo.id) === _this4.worksheetId) {
                gridItemWorksheet.worksheet.set('correctAnswersCount', totalCorrectAnswersCount);
              }
            });
          });
        }
      }
      if ((0, _utils.isPresent)(this.exerciseId) && this.exerciseStore.hasIndexData && (0, _utils.isPresent)(this.userExercise) && (0, _utils.isPresent)(this.exerciseStore.indexData.find(function (item) {
        return (item === null || item === void 0 ? void 0 : item.id) === _this4.exerciseId;
      }))) {
        var exerciseData = this.exerciseStore.indexData.find(function (item) {
          return (item === null || item === void 0 ? void 0 : item.id) === _this4.exerciseId;
        });
        exerciseData.set('correctAnswersCount', this.userExercise.correctAnswersCount);
        exerciseData.set('completed', this.userExercise.completed);
      }
    }
  }, {
    key: "enrichExercise",
    value: function enrichExercise(id, callback) {
      var _this5 = this;
      var exercise = this.findWorksheetExerciseByParam(id);
      var exerciseId = (exercise === null || exercise === void 0 ? void 0 : exercise.id) || id;
      if (exercise && !exercise.enriched || !this.hasWorksheet) {
        this.exerciseStore.getShow({
          queryStrings: {
            include_worksheet: !this.hasWorksheet
          },
          ids: {
            exerciseId: exerciseId
          }
        }, function (resp) {
          _this5.afterGetExercise(resp);
          if (callback) {
            callback();
          }
        });
      }
    }
  }, {
    key: "getWorksheet",
    value: function getWorksheet(worksheetId, callback) {
      var _this6 = this;
      this.worksheetStore.getShow({
        ids: {
          worksheetId: worksheetId
        }
      }, function (resp) {
        _this6.set('worksheetId', resp.id);
        if (_this6.userIsLoaded) {
          _this6.worksheetUserExerciseStore.getIndex({
            ids: {
              worksheetId: resp.id
            }
          });
        }
        if (callback) {
          callback(resp);
        } else {
          _this6.worksheetStore.afterGetShow(resp);
        }
      });
    }
  }, {
    key: "reviewDeckOptions",
    get: function get() {
      var _this7 = this;
      return this.reviewDeckStore.indexData.filter(function (item) {
        return item.languageId === _this7.languageId && !item.archived;
      }).map(function (item) {
        return [item.id, item.name];
      });
    }
  }, {
    key: "worksheetNamespace",
    get: function get() {
      var _this$routeStore2;
      var routeFirstPart = (_this$routeStore2 = this.routeStore) === null || _this$routeStore2 === void 0 || (_this$routeStore2 = _this$routeStore2.routeName) === null || _this$routeStore2 === void 0 ? void 0 : _this$routeStore2.split('.')[0];
      var allowedNamespaces = ['learn', 'worksheets', 'videos', 'podcast'];
      return allowedNamespaces.includes(routeFirstPart) ? routeFirstPart : 'worksheets';
    }
  }, {
    key: "nextExercise",
    get: function get() {
      if (this.hasWorksheet && (0, _utils.isPresent)(this.worksheet.exercises) && !this.exerciseIsLast) {
        return this.worksheet.exercises[this.exerciseIndex + 1];
      }
      return null;
    }
  }, {
    key: "worksheetRouteParam",
    get: function get() {
      var _this$routeStore$para, _this$worksheet4;
      return ((_this$routeStore$para = this.routeStore.params) === null || _this$routeStore$para === void 0 ? void 0 : _this$routeStore$para.worksheetId) || ((_this$worksheet4 = this.worksheet) === null || _this$worksheet4 === void 0 ? void 0 : _this$worksheet4.routeId);
    }
  }, {
    key: "previousExercise",
    get: function get() {
      if (this.hasWorksheet && (0, _utils.isPresent)(this.worksheet.exercises) && !this.exerciseIsFirst) {
        return this.worksheet.exercises[this.exerciseIndex - 1];
      }
      return null;
    }
  }]);
}(_root_state["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "worksheetId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "exerciseId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "assignedExercise", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "revealed", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "currentCardId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "exercises", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "exerciseRatingId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "user", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "user"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userGroup", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userGroup"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "defaultExerciseId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "defaultExerciseId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "site", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "site"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "groupId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "groupId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "languageId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "languageId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "siteIsSeedlang", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "siteIsSeedlang"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "siteIsMemrev", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "siteIsMemrev"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userIsSignedInAndNotGuest", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userIsSignedInAndNotGuest"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "worksheetWords", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "worksheetWords"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "filteredWorksheetWords", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "filteredWorksheetWords"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "worksheetHasInvalidVocab", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "worksheetHasInvalidVocab"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "formattedYoutubeUrl", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "formattedYoutubeUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userExercise", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userExercise"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "worksheet", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "worksheet"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasWorksheet", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasWorksheet"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "exercise", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "exercise"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "exerciseIsLast", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "exerciseIsLast"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "exerciseIsFirst", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "exerciseIsFirst"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "exerciseIndex", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "exerciseIndex"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userIsLoaded", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userIsLoaded"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasExercise", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasExercise"), _class.prototype), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "toggleHideYoutubeVideo", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this8 = this;
    return function () {
      var hideYoutubeVideo = !_this8.user.hideYoutubeVideo;
      _this8.updateUser('hideYoutubeVideo', hideYoutubeVideo);
    };
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "updateUser", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this9 = this;
    return function (field, value) {
      var data = {};
      data[field] = value;
      _this9.user.set(field, value);
      _this9.authUserStore.update({
        data: data
      }, _lodash.noop);
    };
  }
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "assignToNextWordAssociation", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this0 = this;
    return function (submittedWordAssociation, sentenceId, clickWithinSentence) {
      if ((0, _utils.isBlank)(_this0.exercise) || (0, _utils.isBlank)(_this0.exercise.exerciseEntries)) {
        return;
      }
      var assigned = false;
      (0, _lodash.each)(_this0.exercise.exerciseEntries, function (exerciseEntry) {
        if (!assigned && (!clickWithinSentence || !sentenceId || exerciseEntry.sentence.id === sentenceId)) {
          var nextAvailableWordAssociation = exerciseEntry.sentence.wordAssociations.find(function (item) {
            return item.selected && (0, _utils.isBlank)(item.state.submittedValue);
          });
          if ((0, _utils.isPresent)(nextAvailableWordAssociation)) {
            assigned = true;
            exerciseEntry.sentence.state.assignedWordAssociationIds.push(submittedWordAssociation.id);
            _this0.onSetValueToWordAssociation(nextAvailableWordAssociation.id, submittedWordAssociation);
          }
        }
      });
    };
  }
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "assignToNextExerciseEntry", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this1 = this;
    return function (submittedExerciseEntry) {
      var exerciseEntry = _this1.exercise.exerciseEntries.find(function (item) {
        return (0, _utils.isPresent)(item.sentence) && (0, _utils.isBlank)(item.state.assignedExerciseEntry);
      });
      if (exerciseEntry) {
        exerciseEntry.state.set('assignedExerciseEntry', {
          id: submittedExerciseEntry.id,
          prompt: submittedExerciseEntry.prompt
        });
      }
      var submitted = _this1.exercise.exerciseEntries.find(function (item) {
        return item.id === submittedExerciseEntry.id;
      });
      if (submitted) {
        submitted.state.set('assigned', true);
      }
    };
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "removeExerciseEntry", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this10 = this;
    return function (exerciseEntry) {
      var assignedExerciseEntry = _this10.exercise.exerciseEntries.find(function (item) {
        return item.id === exerciseEntry.state.assignedExerciseEntry.id;
      });
      if (assignedExerciseEntry) {
        assignedExerciseEntry.state.set('assigned', false);
      }
      _this10.exercise.state.removeExerciseEntryId(exerciseEntry.state.assignedExerciseEntry.id);
      exerciseEntry.state.reset();
    };
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "onSetValueToWordAssociation", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this11 = this;
    return function (wordAssociationId, submittedWordAssociation) {
      if ((0, _utils.isBlank)(_this11.exercise) || (0, _utils.isBlank)(_this11.exercise.exerciseEntries)) {
        return;
      }
      var wordAssociation;
      (0, _lodash.each)(_this11.exercise.exerciseEntries, function (exerciseEntry) {
        wordAssociation = exerciseEntry.sentence.wordAssociations.find(function (item) {
          return item.id === wordAssociationId;
        });
        if ((0, _utils.isPresent)(wordAssociation)) {
          exerciseEntry.sentence.state.assignedWordAssociationIds.push(submittedWordAssociation.id);
          submittedWordAssociation.state.set('assigned', true);
          wordAssociation.state.set('submittedValue', submittedWordAssociation.targetText);
          wordAssociation.state.set('submittedWordAssociation', submittedWordAssociation);
        }
        if (!_this11.hasWorksheet && exerciseEntry.sentence.allWordAssociationsHaveValues) {
          _this11.revealed = true;
        }
      });
    };
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "clearWordAssociation", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this12 = this;
    return function (wa, sentence) {
      if ((0, _utils.isPresent)(wa.state.submittedWordAssociation)) {
        wa.state.submittedWordAssociation.state.set('assigned', false);
      }
      if (sentence && wa.state.submittedWordAssociation) {
        sentence.state.removeAssignedWordAssociation(wa.state.submittedWordAssociation.id);
      }
      if (wa.state.submittedWordAssociation && _this12.exercise && _this12.exercise.state) {
        _this12.exercise.state.removeAssignedWordAssociation(wa.state.submittedWordAssociation.id);
      }
      wa.state.set('submittedValue', null);
    };
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "setAssignedWordAssociations", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this13 = this;
    return function (wordAssociation, sentence) {
      if (_this13.exercise && _this13.exercise.state) {
        _this13.exercise.state.assignedWordAssociationIds.push(wordAssociation.id);
        if (sentence) {
          sentence.state.assignedWordAssociationIds.push(wordAssociation.id);
        }
      }
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, "correctAnswersCount", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "correctAnswersCount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setUserExerciseValue", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setUserExerciseValue"), _class.prototype), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "reset", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this14 = this;
    return function () {
      _this14.resetExerciseAnswers();
      _this14.currentCardId = null;
    };
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "resetExerciseAnswers", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this15 = this;
    return function () {
      _this15.revealed = false;
      if (_this15.exercise && _this15.exercise.state) {
        _this15.exercise.state.set('revealed', false);
        _this15.exercise.state.reset();
        (0, _lodash.each)(_this15.exercise.exerciseEntries, function (exerciseEntry) {
          exerciseEntry.state.reset();
        });
      }
    };
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "resetIncorrectExerciseAnswers", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this16 = this;
    return function () {
      _this16.revealed = false;
      if (_this16.exercise) {
        _this16.exercise.state.set('revealed', false);
      }
      (0, _lodash.each)(_this16.exercise.exerciseEntries, function (exerciseEntry) {
        _this16.resetIncorrectExerciseEntryAnswers(exerciseEntry);
      });
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, "revealedEntriesCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "revealedEntriesCount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "revealedEntriesCorrectCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "revealedEntriesCorrectCount"), _class.prototype), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "revealExerciseEntryAnswer", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this17 = this;
    return function (exerciseEntry) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var callback = arguments.length > 2 ? arguments[2] : undefined;
      if (_this17.revealedEntriesCount === _this17.exercise.exerciseEntriesCount - 1) {
        _this17.revealExerciseAnswers(params);
      } else {
        exerciseEntry.state.evaluate(_this17.exercise);
        if (!params.skipAudio && exerciseEntry.state.correct) {
          _this17.exercise.set('correctAnswersCount', _this17.revealedEntriesCorrectCount);
          if ((0, _utils.isPresent)(_this17.userExercise)) {
            _this17.setUserExerciseValue('correctAnswersCount', _this17.revealedEntriesCorrectCount);
          }
        }
        if ((0, _utils.isPresent)(_this17.userExercise) && exerciseEntry.state.correct) {
          _this17.worksheetUserExerciseStore.update({
            ids: {
              userExerciseId: _this17.userExercise.id
            },
            data: {
              correct_answers_count: _this17.revealedEntriesCorrectCount,
              submitted_values: _this17.exercise.exerciseEntries.map(function (item) {
                return item.state.submittedValue;
              })
            }
          }, _this17.reloadUser);
        }
      }
      _this17.updateIndexDataAfterReveal();
      if ((0, _lodash.isFunction)(callback)) {
        callback();
      }
    };
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "resetIncorrectExerciseEntryAnswers", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this18 = this;
    return function (exerciseEntry) {
      if (!exerciseEntry.state.correct) {
        var _this18$exercise;
        var skipSentence = ['wordEnter', 'drag'].includes((_this18$exercise = _this18.exercise) === null || _this18$exercise === void 0 || (_this18$exercise = _this18$exercise.exerciseType) === null || _this18$exercise === void 0 ? void 0 : _this18$exercise.slug);
        exerciseEntry.state.reset({
          skipSentence: skipSentence
        });
        if (skipSentence) {
          var _exerciseEntry$senten;
          (_exerciseEntry$senten = exerciseEntry.sentence) === null || _exerciseEntry$senten === void 0 || (_exerciseEntry$senten = _exerciseEntry$senten.wordAssociations) === null || _exerciseEntry$senten === void 0 || _exerciseEntry$senten.forEach(function (wordAssociation) {
            if (wordAssociation.selected && !wordAssociation.state.correct) {
              wordAssociation.state.reset();
            }
          });
        }
      }
      if (_this18.exercise && _this18.exercise.state && _this18.exercise.state.revealed) {
        _this18.exercise.state.set('revealed', false);
      }
    };
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "revealExerciseAnswers", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this19 = this;
    return function () {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var correct = 0;
      if (!_this19.exercise || !_this19.exercise.state) {
        return;
      }
      if (!_this19.exercise.state.revealed) {
        _this19.revealed = true;
        _this19.exercise.state.set('revealed', true);
        _this19.exercise.state.set('hasBeenRevealed', true);
        (0, _lodash.each)(_this19.exercise.exerciseEntries, function (exerciseEntry) {
          exerciseEntry.state.evaluate(_this19.exercise);
          if (exerciseEntry.state.correct) {
            correct += 1;
          }
        });
        if (correct === _this19.exercise.exerciseEntriesCount && params.correctCallback) {
          if (!params.skipAudio) {
            _this19.soundEffectStore.play('horn');
          }
          params.correctCallback();
        } else if (correct === _this19.exercise.exerciseEntriesCount) {
          if (!params.skipAudio) {
            _this19.soundEffectStore.play('horn');
            if (_this19.siteIsSeedlang) {
              _this19.soundEffectStore.play('correct');
            }
          }
          _this19.xpState.createXpAnimation({
            xp: _this19.exercise.exerciseEntriesCount,
            id: (0, _utils.createUuid)(),
            namespace: 'user-exercise-show',
            xpXPos: 200
          });
        } else if (correct !== _this19.exercise.exerciseEntriesCount && params.incorrectCallback) {
          params.incorrectCallback();
        }
        _this19.exercise.set('correctAnswersCount', correct);
        if (_this19.hasWorksheet) {
          _this19.createEvent('memrev - submit exercise', {
            numberCorrect: correct,
            totalQuestions: _this19.exercise.exerciseEntriesCount,
            answeredAllCorrectly: _this19.exercise.exerciseEntriesCount === correct
          });
        }
        if ((0, _utils.isPresent)(_this19.userExercise)) {
          _this19.setUserExerciseValue('correctAnswersCount', correct);
          _this19.worksheetUserExerciseStore.update({
            ids: {
              userExerciseId: _this19.userExercise.id
            },
            data: {
              correct_answers_count: correct,
              xp_slug: 'user-exercise-correct',
              submitted_values: _this19.exercise.exerciseEntries.map(function (item) {
                return item.state.submittedValue;
              })
            }
          }, _this19.reloadUser);
        }
        _this19.updateIndexDataAfterReveal();
      }
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, "updateIndexDataAfterReveal", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateIndexDataAfterReveal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "enrichExercise", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "enrichExercise"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getWorksheet", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "getWorksheet"), _class.prototype), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "reloadUser", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this20 = this;
    return function () {
      if (_this20.userIsLoaded) {
        _this20.authUserStore.getShow({}, _lodash.noop);
      }
    };
  }
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "afterGetExercise", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this21 = this;
    return function (resp) {
      if (_this21.hasWorksheet) {
        var index = (0, _lodash.findIndex)(_this21.worksheet.exercises, function (item) {
          return item.id === resp.id;
        });
        if (index !== -1) {
          _this21.worksheet.exercises[index] = (0, _serializr.deserialize)(_models.Exercise, resp);
        }
      } else {
        _this21.exerciseStore.afterGetShow(resp);
      }
    };
  }
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "markAsCompleted", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this22 = this;
    return function () {
      if ((0, _utils.isPresent)(_this22.userExercise)) {
        var _this22$worksheet;
        var newValue = !_this22.userExercise.completed;
        _this22.setUserExerciseValue('completed', newValue);
        if ((_this22$worksheet = _this22.worksheet) !== null && _this22$worksheet !== void 0 && _this22$worksheet.exercises) {
          var exercise = _this22.worksheet.exercises.find(function (item) {
            return item.id === _this22.exerciseId;
          });
          if (!exercise) return;
          exercise.completed = newValue;
        }
        _this22.updateIndexDataAfterMarkAsCompleted(newValue);
        _this22.worksheetUserExerciseStore.update({
          ids: {
            userExerciseId: _this22.userExercise.id
          },
          data: {
            completed: newValue
          }
        });
      }
    };
  }
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "updateIndexDataAfterMarkAsCompleted", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this23 = this;
    return function (completed) {
      if (_this23.worksheetStore.hasIndexData) {
        _this23.findExerciseAndMarkAsCompleted(_this23.worksheetStore.indexData);
      }
      if (_this23.gridItemStore.hasIndexData) {
        _this23.gridItemStore.indexData.forEach(function (gridItem) {
          _this23.findExerciseAndMarkAsCompleted(gridItem.gridItemWorksheets.map(function (item) {
            return item.worksheet;
          }));
        });
      }
      if (_this23.recentWorksheetStore.hasIndexData) {
        _this23.findExerciseAndMarkAsCompleted(_this23.recentWorksheetStore.indexData);
      }
      if (_this23.exerciseStore.hasIndexData) {
        _this23.exerciseStore.indexData.forEach(function (item) {
          if ((item === null || item === void 0 ? void 0 : item.id) === _this23.exerciseId) {
            item.set('completed', completed);
          }
        });
      }
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, "reviewDeckOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "reviewDeckOptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "worksheetNamespace", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "worksheetNamespace"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "nextExercise", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "nextExercise"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "worksheetRouteParam", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "worksheetRouteParam"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "previousExercise", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "previousExercise"), _class.prototype), _class);
var _default = exports["default"] = new ExerciseUI();